<template>
  <div style="width: 100%" class="nx-nav-bar-w">
    <van-nav-bar
      v-bind="$attrs"
      class="nx-nav-bar"
      :class="!showBgColor ? 'hide-bg-color' : ''"
      :title="title"
      :right-text="rightText"
      left-arrow
      :fixed="true"
      :placeholder="true"
      :safe-area-inset-top="true"
      @click-left="onClickLeft"
      @click-right="onClickRight"
    >
      <template #left>
        <slot name="left" />
      </template>
      <template #title>
        <slot name="title" />
      </template>
      <template #right>
        <slot name="right" />
      </template>

    </van-nav-bar>
  </div>
</template>
<script>
export default {
  name: 'NxNavBar',
  props: {
    rightText: {
      type: String,
      default: '',
    },
    showTitle: {
      type: Boolean,
      default: () => true,
    },
    showBgColor: {
      type: Boolean,
      default: () => true,
    },
    customTitle: {
      type: String,
      default: '',
    },
    clickLeft: Function,
    clickRight: Function,
  },
  computed: {
    title() {
      return this.showTitle ? this.customTitle || this.$route.meta.title || '' : '';
    },
  },
  methods: {
    onClickLeft() {
      if (!this.clickLeft) {
        // 默认返回上一页面
        return this.$router.back();
      }
      this.clickLeft?.();
    },
    onClickRight() {
      this.clickRight?.();
    },
  },
};
</script>
<style lang="scss" scoped>
// .nx-nav-bar-w{
//   height: 46px;
//   position: relative;
//   z-index: 11;
// }
.hide-bg-color{
  :deep(.van-nav-bar ) {
    background-color: inherit !important;
  }
}
.nx-nav-bar {
  height: 46px;
  position: relative;
  z-index: 11;
  .van-nav-bar {
    height: 46px;
  }
  .van-nav-bar__content {
    height: 46px;
  }
  .van-nav-bar__arrow {
    font-size: 20px;
    color: #262626 !important;
  }
  .van-nav-bar__title {
    font-size: 16px;
    font-weight: 500;
    color: #363D4D;
  }
  .van-nav-bar__right {
    font-size: 14px;
    font-weight: 400;
    .van-nav-bar__text {
      color: #262626;
    }
  }
  :deep(.van-nav-bar__arrow) {
    color: #262626;
  }
}
</style>
